import { ROUTES } from '@/routes/paths';

/**
 * A dónde volver después de iniciar sesión o registrarse.
 *
 * `RequireAuth` redirige a `/login` con `state={{ from }}` (la ruta protegida que el usuario
 * quería abrir), así que tras autenticarse se vuelve ahí. Si no hay `from` utilizable, se
 * entra al Panel.
 *
 * Solo se aceptan rutas internas (empiezan por `/`) porque el `state` vive en el historial
 * del navegador y no queremos navegar a una URL externa por un valor manipulado.
 */
export function resolveAuthRedirect(state: unknown, fallback: string = ROUTES.dashboard): string {
  if (typeof state === 'object' && state !== null && 'from' in state) {
    const from = (state as { from?: unknown }).from;

    if (typeof from === 'string' && from.startsWith('/') && !from.startsWith('//')) {
      return from;
    }
  }

  return fallback;
}
